const getErrorMessage=(data)=>{
    let palor={};
    Object.keys(data).forEach(k=>palor={...palor,[k]:data[k].message})
    return  palor;
  }
  export default getErrorMessage;